// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"163":"f73e831f","193":"976aae30","519":"976aae30","587":"976aae30"}[chunkId] + ".chunk.css";
};